const calculatePrice = (options, basePrice) => {
  const price = options.reduce((sum, option) => {
    const priceDiff = option?.price_diff || 0;
    return sum + priceDiff;
  }, Number(basePrice));
  return price;
};

export const calculateComparePrice = (options, basePrice) => {
  const price = options.reduce((sum, option) => {
    const optionCompareAtPrice =
      option?.compared_at_price_diff && option?.compared_at_price_diff !== 0
        ? option?.compared_at_price_diff
        : option?.price_diff || 0;
    return sum + optionCompareAtPrice;
  }, Number(basePrice));
  return price;
};

export default calculatePrice;
